import { Category } from '@/types/summary'
import { LabelKey, LabelValues } from '.'

interface Props {
  categories: Category[]
}
export const Genre: React.FC<Props> = ({ categories }) => {
  return (
    <div className="sm:flex sm:pb-[6px] w-full text-[15px] sm:text-base leading-9 sm:leading-base align-top sm:align-middle">
      <LabelKey text="ジャンル" />
      <LabelValues type="category" values={categories} />
    </div>
  )
}
